export default () => {
    return (
        <div className="page-footer">©copyright</div>
    )
}